export const WEBURL = 'https://www.evlastnici.cz';
/** Produkční aplikace — demo na ni odkazuje tam, kde samo funkci nenabízí (registrace domu). */
export const APP_URL = 'https://app.evlastnici.cz';
export const CONTACT_URL = 'https://aplikace.evlastnici.cz/kontakt';
/** Mobilní aplikace eVlastníci (jen pro vlastníky) — odkazy do storů pro MobileAppBanner. */
export const APP_STORE_URL = 'https://apps.apple.com/app/id1609480786';
export const GOOGLE_PLAY_URL = 'https://play.google.com/store/apps/details?id=com.evlastnici.eVlastnici';
export const FLASH_MESSAGE_TIMEOUT = 3500;

export const POLL_END_MIN_DAYS = 15;
export const POLL_PUBLIC_MIN_DAYS = 1;

export const isDemo = import.meta.env.VITE_DEMO ? true : false;

export const demoUserCredentials = { email: 'jaroslav.kasparek@evlastnici.cz ', password: 'demo' };
export const demoAdminCredentials = { email: 'demo@evlastnici.cz', password: 'demo' };
